<template>
  <div
    class="new-pc-header"
    ref="homeHeader"
    :class="[currentPage, headerClass]"
  >
    <div class="main">
      <div class="lt">
        <img
          :src="
            require(`@/assets/images/detail/mobile-legends/desktop/new-hander-logo.png`)
          "
          @click="goBack"
        />
        <span>{{ $t('about.deals_guaranteed') }}</span>
      </div>
      <div class="rt" v-if="!isFeedback">
        <template v-if="!isPayResult">
          <RegionLangPopup
            :addClass="'new-pc-wrapper'"
            :page="gameName"
            v-show="showRegionAndUser"
          />
          <span class="separator"></span>
        </template>

        <!-- KB显示 -->
        <div class="kb-quantity" v-if="isRenderWellet">
          <img :src="require(`@/assets/images/wallet/K-coin.png`)" />
          <span> {{ accountBalance | formatCurrency(region) }}</span>
        </div>
        <UserCenter
          :addClass="'new-pc-login'"
          :page="gameName"
          ref="loginComp"
          @login="getLoginResult"
          v-show="showRegionAndUser"
          :parentContainer="
            currentPage === 'home'
              ? '.home-page-container'
              : '.new-details-pc-content'
          "
        />
      </div>
    </div>
  </div>
</template>
<script>
  import RegionLangPopup from '@/components/RegionLangPopup'
  import UserCenter from '@/components/UserCenter'
  import MixinSrcoll from '@/mixins/detail/mixinSrcoll'
  import { backHome } from '@/pages/firebase'
  import { mapState, mapGetters } from 'vuex'
  import { priceFormat } from '@/utils/priceFormat'
  import { getCurrentPage } from '@/utils/utils.js'

  const _mixinSrcoll = new MixinSrcoll(10)

  export default {
    name: 'new-pc-header', // pc端游戏详情页
    mixins: [_mixinSrcoll],
    components: {
      RegionLangPopup,
      UserCenter,
    },
    props: {
      backimg: {
        type: String,
        default: '',
      },
      showRegion: {
        default: false,
        type: Boolean,
      },
      isFeedback: {
        default: false,
        type: Boolean,
      },
      //warn: 结果页不能展示切换国家组件
      isPayResult: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        btnFlag: false,
        defaultImg: require('@/assets/images/detail/mobile-legends/desktop/new-banner.png'),
        headerClass: '', // header是否滚动到指定位置的类名
      }
    },
    computed: {
      ...mapState([
        'isGetapps',
        'region',
        'gameName',
        'source',
        'paymentAccountInfo',
        'allowUseMember',
      ]),
      ...mapGetters(['isLogin', 'isGenshinEn']),
      currentPage() {
        return getCurrentPage(this.$route.path)
      },
      accountStatus() {
        // 支付账户状态：1正常 2冻结 3注销
        return (this.paymentAccountInfo && this.paymentAccountInfo.status) || 1
      },
      accountBalance() {
        return (this.paymentAccountInfo && this.paymentAccountInfo.amount) || 0
      },

      // 显示钱包的数量：
      // 1、登录状态；2、钱包为正常的状态
      isRenderWellet() {
        return this.isLogin && this.accountStatus === 1 && this.allowUseMember
      },
      showRegionAndUser() {
        if (this.showRegion) return true
        const showPage = [
          'home',
          // 'feedback',
          // 'feedback-answer',
          // 'feedback-edit',
          // 'feedback-record',
          // 'search-order',
        ]
        if (showPage.includes(this.currentPage)) return true
        if (this.isGenshinEn) return false
        return true
      },
    },
    filters: {
      formatCurrency(input, region) {
        return priceFormat(input, region, {
          style: 'decimal',
          minimumFractionDigits: 0,
        })
      },
    },
    created() {},
    mounted() {
      this.$nextTick(() => {
        this.headerHeight = this.$refs.homeHeader.offsetHeight || 0
        window.addEventListener('scroll', this.scroll, true)
      })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scroll)
    },
    methods: {
      login(type = '') {
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      getLoginResult(res) {
        this.$emit('login', res)
      },
      goBack() {
        if (this.isFeedback) {
          this.$router_push({
            path: `/home`,
            query: {
              ...this.$route.query,
            },
          })
          return
        }
        if (this.isGenshinEn || this.isGetapps) {
          return
        }
        backHome({ page: this.gameName })
        let query = { source: this.source }
        this.isPwa && Object.assign(query, { isPwa: true })
        if (this.$route.query.home === 'true') {
          this.$router_push({
            path: `/home`,
            query: {
              ...this.$route.query,
              ...query,
            },
          })
        } else {
          this.$router_push({
            path: `/`,
            query: {
              ...this.$route.query,
              ...query,
            },
          })
        }
      },
      scroll() {
        const scrollTop = document.documentElement.scrollTop || 0
        this.headerClass = scrollTop > this.headerHeight / 2 ? 'scroll' : ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
  @media (max-width: 1280px) {
    @import './1280.scss';
  }
</style>
